import {
  polyfillURLPattern,
  isURLPatternSupported,
  isNavigationSupported,
  polyfillNavigation
} from '@react-motion-router/core';

export const MIN_CASHTAG_LENGTH = 2;
export const MILLISECONDS_PER_SECOND = 1000;
export const PLAYER_DEFAULT_TOKEN_SCOPE = 'transaction-request.get transaction-request-response.get user.get user.patch transaction.get transaction.post game.post game.get account.get transaction-request.post transaction-request-response.post';
export const TOKEN_KEY = ['token'] as const;
export const TRANSACTIONS_KEY = ['transactions'] as const;
export const PREVIEW_TRANSACTIONS_KEY = [...TRANSACTIONS_KEY, 'preview'] as const;
export const LAST_TRANSACTION_KEY = [...TRANSACTIONS_KEY, 'last'] as const;
export const TRANSACTION_REQUESTS_KEY = [...TRANSACTIONS_KEY, 'requests'] as const;
export const AVATAR_KEY = ['avatar'] as const;
export const PREVIEW_TRANSACTION_REQUESTS_KEY = [...TRANSACTION_REQUESTS_KEY, 'preview'] as const;
export const TRANSACTION_REQUEST_RESPONSES_KEY = [...TRANSACTION_REQUESTS_KEY, 'responses'] as const;
export const USER_ACCOUNT_KEY = ['user-account'] as const;
export const SYSTEM_ACCOUNTS_KEY = ['system-accounts'] as const;
export const BANK_SYSTEM_ACCOUNTS_KEY = [...SYSTEM_ACCOUNTS_KEY, 'bank'] as const;
export const FREE_PARKING_SYSTEM_ACCOUNTS_KEY = [...SYSTEM_ACCOUNTS_KEY, 'free_parking'] as const;
export const USER_KEY = ['user'] as const;
export const GAME_KEY = ['game'] as const;
export const ATTESTATION_KEY = ['attestation'] as const;
export const ASSERTION_KEY = ['assertion'] as const;
export const EVENTS_KEY = ['events'] as const;
export const INITIAL_FONTS_READY = document.fonts.ready.then(faces => {
  return Promise.all([...faces].map(face => face.load()));
});
export const POLYFILLS = Promise.all([
  isURLPatternSupported()
    ? Promise.resolve()
    : polyfillURLPattern(),
  isNavigationSupported()
    ? Promise.resolve()
    : polyfillNavigation(),
]);